import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {from, Observable, of} from "rxjs";
import {Article} from "@interfaces/article";
import {inject} from "@angular/core";
import {ArticlesRepository} from "@app/repositories/articles.repository";
import {ArticlesService} from "@services/api/articles.service";

export const ArticleResolver: ResolveFn<Article | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<Article | undefined> => {
  const articleSlug = route.paramMap.get('articleSlug');
  const categorySlug = route.paramMap.get('categorySlug');
  console.log(`${ArticleResolver.name}`, articleSlug);

  if (!articleSlug) {
    return of(undefined);
  }

  const articlesRepository = inject(ArticlesRepository);
  const articlesService = inject(ArticlesService);

  return from((async (): Promise<Article | undefined> => {
    const article = await articlesRepository.findBySlug(articleSlug);
    if (article) {
      return article;
    }

    if (!categorySlug) {
      return undefined;
    }

    return await articlesService.getOneFromApiBySlug(categorySlug, articleSlug);
  })());
};
